/**
 * WiPay country hosts — must match Cloud Functions `wipayVerificationCore.js`.
 * @see https://docs.wipayfinancial.com/platforms-and-environments
 */
const COUNTRY_BASE_URLS = {
  BB: { live: 'https://bb.wipayfinancial.com', sandbox: 'https://bbsb.wipayfinancial.com' },
  GD: { live: 'https://gd.wipayfinancial.com', sandbox: 'https://gdsb.wipayfinancial.com' },
  GY: { live: 'https://gy.wipayfinancial.com', sandbox: 'https://gysb.wipayfinancial.com' },
  JM: { live: 'https://jm.wipayfinancial.com', sandbox: 'https://jmsb.wipayfinancial.com' },
  TT: { live: 'https://tt.wipayfinancial.com', sandbox: 'https://ttsb.wipayfinancial.com' },
};

const PAYMENTS_REQUEST_PATH = '/plugins/payments/request';

/**
 * @param {string} [countryCode]
 * @param {string} [environment] `live` or `sandbox`
 */
export function getWipayPaymentsBaseUrl(countryCode = 'JM', environment = 'sandbox') {
  const country = String(countryCode || 'JM').toUpperCase();
  const urls = COUNTRY_BASE_URLS[country] || COUNTRY_BASE_URLS.JM;
  const env = String(environment || 'sandbox').toLowerCase();
  return env === 'live' ? urls.live : urls.sandbox;
}

/**
 * Full Payments API request URL for the country + environment.
 */
export function getWipayPaymentRequestUrl(countryCode = 'JM', environment = 'sandbox') {
  return `${getWipayPaymentsBaseUrl(countryCode, environment)}${PAYMENTS_REQUEST_PATH}`;
}

export function resolveWipayCountryCode() {
  const fromEnv = process.env.REACT_APP_WIPAY_COUNTRY_CODE;
  if (fromEnv && /^[A-Z]{2}$/i.test(fromEnv)) {
    return fromEnv.toUpperCase();
  }
  return 'JM';
}

export function resolveWipayEnvironment() {
  const fromEnv = process.env.REACT_APP_WIPAY_ENVIRONMENT;
  if (fromEnv && typeof fromEnv === 'string') {
    return fromEnv.toLowerCase();
  }
  return 'sandbox';
}
